import styled from '@emotion/styled'
import { Shapes } from 'src/components/theme'

export const SubscriptionModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${Shapes.spacing[2]}px;
`
